var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.9@core-js/library/modules/_an-object.js
// module id = ./node_modules/_core-js@2.6.9@core-js/library/modules/_an-object.js
// module chunks = 6